const roundToN = (num: number, decimalPlaces: number) => {
  if (decimalPlaces <= 0) {
    throw new Error("decimalPlaces must be greater than 0");
  }

  if (decimalPlaces >= 11) {
    throw new Error("decimalPlaces must be less than or equal to 10");
  }

  const scaleFactor = 10 ** decimalPlaces;
  return Math.round((num + Number.EPSILON) * scaleFactor) / scaleFactor;
};

export default roundToN;
